<template>
    <div id="wrapper">
        <SidebarView :transactionImports="true" :transaction="true" :transVisible="true" />
        <div class="d-flex flex-column" id="content-wrapper">
            <div id="content">
                <TopbarView />

                <div class="container-fluid">
                    <!-- <div class="card card-shape home-box">
              
            </div> -->
                    <div>
                        <b-card no-body class="card-shape home-box">
                            <b-tabs card>
                                <b-tab title="Bulk Deposit Import" active>
                                    <BulkDeposits />
                                </b-tab>
                                <b-tab title="Bulk Withdrawal Imports">
                                    <BulkWithdrawals />
                                </b-tab>
                                <b-tab title="Bulk Transfer(P to P) (A/C)">
                                    <BulkTransferP2P />
                                </b-tab>
                                <b-tab title="Bulk Transfer(P to P) (Member Code)">
                                    <BulkTransferP2PMemberCode />
                                </b-tab>
                            </b-tabs>
                        </b-card>
                    </div>
                </div>
            </div>
            <footer></footer>
        </div>

        <!-- AI -->
		 <ChatBot />
		<!-- End AI -->
        <a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
    </div>
</template>
<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import BulkDeposits from "./BulkDeposits.vue";
import BulkWithdrawals from "./BulkWithdrawals.vue";
import BulkTransferP2P from "./BulkTransferP2P.vue";
import BulkTransferP2PMemberCode from "./BulkTransferP2PMemberCode.vue";
import ChatBot from "@/views/components/AI/ChatBot.vue";

export default {
    components: {
        SidebarView,
        TopbarView,
        Footer,
        BulkDeposits,
        BulkWithdrawals,
        BulkTransferP2P,
        BulkTransferP2PMemberCode,
        ChatBot,
    },
};
</script>